import { useHttp } from '../http'

export const useTagSectionHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`tag-sections/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`tag-sections`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`tag-sections/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`tag-sections`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`tag-sections/${id}`)
    }

    return {
        find,
        create,
        update,
        get,
        del,
    }
}
